"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    failedActionCall: 'Misslyckade skrivningar' || 'failedActionCall',
    writeFailedActionCall: 'Skapa misslyckad skriving' || 'writeFailedActionCall',
    retry: 'Försök igen' || 'retry',
    markAsObsolete: 'Markera som utdaterad' || 'markAsObsolete',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    integration: 'Integration' || 'integration',
    origin: 'Ursprung' || 'origin',
    status: 'Status' || 'status',
    statuses: {
        error: 'Misslyckades' || 'error',
        resolved: 'Åtgärdat' || 'resolved',
        obsolete: 'Utdaterad' || 'obsolete',
    },
    errorMessage: 'Felmeddelande' || 'errorMessage',
    stackTrace: 'Spårning' || 'stackTrace',
    brokerOptions: 'Användardata' || 'brokerOptions',
    action: 'Åtgärd' || 'action',
    actionParamsS3Path: 'Innehåll på S3' || 'actionParamsS3Path',
    keywords: 'Sökord' || 'keywords',
    incomingMessage: 'Inkommande meddelande' || 'incomingMessage',
};
